var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16Z",
    fill: "#474A57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m21.569 17.193.664-3.679h-4.155v-2.386c0-1.006.579-1.988 2.44-1.988h1.89V6.008s-1.714-.248-3.353-.248c-3.424 0-5.66 1.762-5.66 4.95v2.804H9.591v3.679h3.805v8.893c.763.102 1.545.154 2.34.154.796 0 1.578-.052 2.342-.154v-8.893h3.49Z",
    fill: "#fff"
  })));
};
export default SvgFacebook;